export default __webpack_public_path__ + "static/media/money-back.0a381a3c.svg";